import { Box, Stack } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FontStyle, Slug } from "../constants";
import * as apiService from "../service/ApiService";

const styles = {
  container: {
    // position: "absolute",
    // bottom: 0,
    // left: 0,
    // transform: "translate(0, 100%)",
    width: "100%",
    py: 1,
    ...FontStyle.body,
    background: {
      xs: "#3BF77A",
      md: "linear-gradient(180deg, #3BF77A 50%, #3BF77A80)",
    },
    fontSize: "14px",
    textAlign: "center",
    px: 2,
  },
};

const VerifyEmailBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const auth = useSelector((state) => state.auth);
  const handleResend = () => {
    console.log("resend");
    apiService.requestVerifyEmail(dispatch, auth.accountData);
    navigate({
      pathname: Slug.sentVerificationEmail + "/",
      // send email
      // search: {
      //   email: auth.accountData.email,
      // },
      search: `?email=${auth.accountData.contactInfo}`,
    });
  };
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      justifyContent="center"
      alignItems="center"
      spacing={0.5}
      sx={styles.container}>
      <span style={{ fontWeight: "bold" }}>
        Verify your email to get the most out of Fetti. Didn't receive an email?
      </span>
      <Box
        sx={{
          display: "inline-block",
          textDecoration: "underline",
          cursor: "pointer",
        }}
        onClick={handleResend}>
        Resend confirmation
      </Box>
    </Stack>
  );
};

export default VerifyEmailBar;
